import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { B2BLanding } from '../components/B2BLanding';
import { kbeautyContent } from '../content/kbeautyContent';

export default function KBeautyPage() {
  const { language } = useLanguage();
  return <B2BLanding content={kbeautyContent[language]} seoKey="kbeauty" path="/cosmetici-coreani" heroImage="/images/kbeauty/skin1004.jpg" testId="kbeauty-page" />;
}
